import { getCityByRegion } from './getCityByRegion';
import { getIpData } from './getIpData';

export const getCityDomainByGeoIpService = async(ip: string): Promise<string | undefined> => {
    const cityData = await getIpData(ip);
    if (cityData) {
        return getCityByRegion(cityData);
    }
};
